import React from 'react';
import styled from 'styled-components';
import { AlertTriangle, Mail } from 'react-feather';
import { style } from '../../api';
import { Modal } from '../common/Modal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const BlockedAccountDialog: React.FC<Props> = ({ isOpen, onClose }) => (
  <Modal
    isOpened={isOpen}
    toggle={onClose}
    width={480}
    style={{
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        zIndex: 9999,
      },
      content: {
        padding: '0',
        border: 'none',
        borderRadius: '16px',
        overflow: 'hidden',
      },
    }}
  >
    <Container>
      <IconWrapper>
        <AlertTriangle size={40} color="#ff4d4f" />
      </IconWrapper>

      <Title>Account Suspended</Title>

      <Description>
        Your account has been suspended due to multiple violations of our{' '}
        <strong>Terms of Service</strong> and <strong>Legal Policies</strong>.
      </Description>

      <Description>
        This action was taken after careful review. If you believe this is an
        error, please contact our support team.
      </Description>

      <Divider />

      <ContactSection>
        <ContactLabel>Need help?</ContactLabel>
        <ContactLink href="mailto:hello@virpp.com">
          <Mail size={16} />
          hello@virpp.com
        </ContactLink>
      </ContactSection>
    </Container>
  </Modal>
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 32px 32px;
  text-align: center;
`;

const IconWrapper = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(255, 77, 79, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`;

const Title = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: ${style.black};
  margin: 0 0 16px;
`;

const Description = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: #555;
  margin: 0 0 8px;

  strong {
    color: ${style.black};
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${style.pageTitleDividerGrey || '#eee'};
  margin: 24px 0;
`;

const ContactSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0;
  margin-bottom: 24px;

  > * + * {
    margin-top: 8px;
  }
`;

const ContactLabel = styled.span`
  font-size: 13px;
  color: #888;
`;

const ContactLink = styled.a`
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #e91e63 !important;
  text-decoration: none;
  cursor: pointer;

  svg {
    margin-right: 8px;
  }

  &:hover {
    text-decoration: underline;
  }
`;

export default BlockedAccountDialog;
